import { motion, useScroll, useSpring } from "framer-motion";

export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 26 });
  return (
    <motion.div
      data-testid="scroll-progress"
      className="fixed left-0 right-0 top-0 z-[80] h-[2.5px] origin-left bg-gradient-to-r from-blue-500 via-cyan-400 to-cyan-300 shadow-[0_0_10px_rgba(0,229,255,0.6)]"
      style={{ scaleX }}
    />
  );
};
